import MenuQuery from 'Query/Menu.query';
import MenuHelper from 'Util/Menu';
import DataContainer from 'Util/Request/DataContainer';

import Menuq from './Menuq.component';

export class MenuqContainer extends DataContainer {
    state = {
        activeMenuItemsStack: [],
        menu: {}
    };

    containerFunctions = {
        handleSubcategoryClick: this.handleSubcategoryClick.bind(this),
        handleTopLevelClick: this.handleTopLevelClick.bind(this)
    };

    componentDidMount() {
        this._getMenu();

        // window.addEventListener('popstate', this.historyBackHook);
    }

    historyBackHook() {
        const { activeMenuItemsStack } = this.state;

        if (activeMenuItemsStack.length) {
            this.setState({ activeMenuItemsStack: activeMenuItemsStack.slice(1) });
        }
    }

    componentWillUnmount() {
        // window.removeEventListener('popstate', this.historyBackHook);
    }

    containerProps() {
        const { activeMenuItemsStack, menu } = this.state;

        return {
            activeMenuItemsStack,
            menu
        };
    }

    _getMenuOptions() {
        return {
            identifier: 'new-main-menu'
        };
    }

    _getMenu() {
        this.fetchData(
            [MenuQuery.getQuery(this._getMenuOptions())],
            ({ menu }) => {
                const menuReduced = MenuHelper.reduce(menu);

                // default active elements
                const productsObj = menuReduced[Object.keys(menuReduced)[0]].children;
                const tenObj = productsObj[Object.keys(productsObj)[0]];
                const tenChildrenIds = Object.values(tenObj.children).map(({ item_id }) => item_id);

                this.setState({
                    menu: menuReduced,
                    activeMenuItemsStack: [ tenObj.item_id, ...tenChildrenIds ]
                })
            }
        );
    }

    getNewActiveMenuItemsStack(activeMenuItemsStack, item_id) {
        if (activeMenuItemsStack.includes(item_id)) {
            return activeMenuItemsStack.filter((id) => id !== item_id);
        }

        return [item_id, ...activeMenuItemsStack];
    }

    handleSubcategoryClick(e, activeSubcategory) {
        const { activeMenuItemsStack } = this.state;
        const { item_id } = activeSubcategory;

        e.stopPropagation();

        const newActiveMenuItemsStack = this.getNewActiveMenuItemsStack(activeMenuItemsStack, item_id);
        this.setState({ activeMenuItemsStack: newActiveMenuItemsStack });
    }

    handleTopLevelClick(e, activeSubcategory, childrenArray) {
        e.stopPropagation();

        const { item_id } = activeSubcategory;
        const childrenIds = childrenArray.map(({ item_id }) => item_id)

        this.setState({ activeMenuItemsStack: [item_id, ...childrenIds] });
    }

    render() {
        return (
            <Menuq
              { ...this.containerProps() }
              { ...this.containerFunctions }
            />
        );
    }
}

export default MenuqContainer;
